import FormText from 'components/form/FormText';

import { useState, type JSX } from 'react';
import { useForm } from 'react-hook-form';
import ReactModal from 'react-modal';
import { submit } from 'utils/app';

/**
 * QuillEditorボタン登録モーダル
 */
export default function QuillModalButton(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  onSubmit: (buttonText: string, buttonUrl: string) => void;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type FormStateType = {
    buttonText: string;
    buttonUrl: string;
  };
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [processing, setProcessing] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<FormStateType>();
  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じる処理
   */
  const onClose = () => {
    props.setOpen(false);
    clearErrors();
  };

  const onAfterOpen = () => {
    setValue('buttonText', '');
    setValue('buttonUrl', '');
  };

  /**
   * 設定ボタン押下時の処理
   */
  const onSubmit = () =>
    submit(
      processing,
      setProcessing,
      handleSubmit((data: FormStateType) => {
        props.onSubmit(data.buttonText, data.buttonUrl);
        onClose();
      })
    );

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onAfterOpen={onAfterOpen}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: 'rgba(30, 30, 30,0.5)',
          },
          content: {
            maxWidth: '500px',
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div
          id="settings-modal"
          className="modal2 modal-content rounded-4"
          style={{ maxWidth: 'none' }}
        >
          <div className="modal-body mt-4">
            <div className="row  pt-1">
              <p className="col-4 col-md-4 text-end">テキスト</p>
              <div className="col-6 col-md-7">
                <FormText
                  name="buttonText"
                  placeholder="ボタンテキスト"
                  className="form-controll-small"
                  register={register}
                  required={true}
                  errors={errors}
                />
              </div>
            </div>
            <div className="row  pt-1">
              <p className="col-4 col-md-4  text-end">URL</p>
              <div className="col-6 col-md-7">
                <FormText
                  name="buttonUrl"
                  placeholder="https://example.com"
                  className="form-controll-small"
                  register={register}
                  required={true}
                  format="url"
                  errors={errors}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer border-top-0 justify-content-center mt-2 mb-4">
            <button onClick={onClose} type="button" className="btn btn-secondary">
              キャンセル
            </button>
            <button onClick={onSubmit} type="button" className="btn btn-submit">
              設定完了
            </button>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
